import { Z_INDEX } from "@/style/zIndex";
import { css } from "@emotion/react";

import { useTabs } from "@/hooks/useTabs";
import { DESIGN_TOKEN_COLOR } from "@/style/designTokens";
import { useFunnelModal } from "@/hooks/useFunnelModal";

export type TabProps<T extends string> = Omit<ReturnType<typeof useTabs<T>>, "tabs"> & { tab: T };

type TabsProps<T extends string> = ReturnType<typeof useTabs<T>> & {
  TabComp: React.ComponentType<TabProps<T>>;
};

export function TemplateListTab<T extends string>({ tabs, curTab, selectTab, TabComp }: TabsProps<T>) {
  const { funnelModalState } = useFunnelModal();

  const BACKGROUND_COLORS: Record<string, string> = {
    listTemplate: DESIGN_TOKEN_COLOR.gray100,
  };

  const curBackgroundColor = (funnelModalState.step && BACKGROUND_COLORS[funnelModalState.step]) ?? "#fff";

  return (
    <div
      className="template-list-tab-container"
      css={[
        css`
          width: 100%;
          position: sticky;
          top: 5.7rem;
          background-color: ${curBackgroundColor};
          display: inline-flex;
          gap: 0.8rem;
          padding-top: 2rem;
          z-index: ${Z_INDEX.sticky};
          border-bottom: 0.2rem solid ${DESIGN_TOKEN_COLOR.gray200};
        `,
      ]}
    >
      {tabs.map((tab, index) => {
        return <TabComp key={index} selectTab={selectTab} curTab={curTab} tab={tab} />;
      })}
    </div>
  );
}
